import React, { useState } from 'react';
import Footer from "../../Components/Footer"
import Navbar from "../../Components/Navbar"

const Forththeme = ({ get_data }) => {
    const [cart, setCart] = useState([]);
    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    const phone = get_data?.mobile || get_data?.contact_no || null;
    const email = get_data?.email || "contact@reliep.com";
    const address = get_data?.service_address || "123 Business Avenue";
    const reviews = Array.isArray(get_data?.review_ratings) ? get_data.review_ratings : [];
    const products = Array.isArray(get_data?.product_services) ? get_data.product_services : [];
    const categories = Array.isArray(get_data?.categories) ? get_data.categories : [];

    return (
        <>
            <style>{`
        :root {
            --primary: #0f172a;
            --primary-light: #1e293b;
            --accent: #d97706;
            --accent-light: #f59e0b;
            --text-dark: #0f172a;
            --text-gray: #64748b;
            --text-light: #f8fafc;
            --bg-light: #f8fafc;
            --white: #ffffff;
            --radius: 12px;
            --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
            --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
        }

        /* Basic Resets & Fonts */
        body { font-family: 'Outfit', sans-serif; color: var(--text-dark); background-color: var(--bg-light); margin: 0; padding: 0; line-height: 1.6; }
        h1, h2, h3, h4 { font-weight: 700; line-height: 1.2; }
        a { text-decoration: none; color: inherit; transition: 0.3s; }
        ul { list-style: none; padding: 0; margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
        .section { padding: 80px 0; }
        
        /* Buttons */
        .btn { display: inline-flex; align-items: center; padding: 12px 28px; border-radius: 50px; font-weight: 600; cursor: pointer; transition: 0.3s; border: none; font-size: 0.95rem; }
        .btn-primary { background: var(--accent); color: var(--white); box-shadow: 0 4px 14px rgba(245, 158, 11, 0.4); }
        .btn-primary:hover { background: var(--accent-light); transform: translateY(-2px); }
        .btn-outline { background: transparent; border: 2px solid var(--accent); color: var(--accent); }
        .btn-outline:hover { background: var(--accent); color: var(--white); }

        /* Top Bar */
        .top-bar { background-color: var(--primary); color: var(--text-light); padding: 12px 0; font-size: 0.9rem; }
        .top-bar .container { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px; }
        .contact-info { display: flex; gap: 24px; flex-wrap: wrap; }
        .info-item { display: flex; align-items: center; gap: 8px; }
        
        /* Hero */
        .hero { background: var(--primary); color: var(--white); padding: 100px 0; position: relative; overflow: hidden; }
        .hero .container { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center; position: relative; z-index: 1; }
        .hero h1 { font-family: 'Playfair Display', serif; font-size: 3.5rem; margin-bottom: 24px; }
        .hero p { font-size: 1.2rem; color: #cbd5e1; margin-bottom: 30px; }
        .hero img { width: 100%; border-radius: 20px; box-shadow: 0 20px 40px rgba(0,0,0,0.3); border: 8px solid rgba(255,255,255,0.1); }
        
        /* Section Header */
        .section-header { text-align: center; max-width: 700px; margin: 0 auto 60px; }
        .section-header span { text-transform: uppercase; letter-spacing: 2px; color: var(--accent); font-weight: 600; font-size: 0.85rem; display: block; margin-bottom: 12px; }
        .section-header h2 { font-size: 2.5rem; color: var(--primary); font-family: 'Playfair Display', serif; }

        /* Cards (Services/Products) */
        .grid-3 { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 30px; }
        .card { background: var(--white); border-radius: 16px; overflow: hidden; box-shadow: var(--shadow-sm); transition: 0.3s; border: 1px solid #e2e8f0; }
        .card:hover { transform: translateY(-8px); box-shadow: var(--shadow-lg); border-color: var(--accent); }
        .card-img { height: 200px; width: 100%; object-fit: cover; }
        .card-body { padding: 24px; }
        .card-title { font-size: 1.25rem; margin-bottom: 12px; color: var(--primary); }
        .card-price { color: var(--accent); font-weight: 700; font-size: 1.1rem; margin-bottom: 16px; display: block; }

        /* Testimonials */
        .review-card { background: var(--white); padding: 30px; border-radius: 16px; box-shadow: var(--shadow-sm); }
        .rating { color: var(--accent); margin-bottom: 16px; }

        @media (max-width: 992px) {
            .hero .container { grid-template-columns: 1fr; text-align: center; }
            .hero h1 { font-size: 2.5rem; }
        }
            `}</style>

            <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,600;1,600&display=swap" rel="stylesheet" />

            <div className="top-bar">
                <div className="container">
                    <div className="contact-info">
                        <div className="info-item"><span>📧 {email}</span></div>
                        <div className="info-item"><span>📞 {phone}</span></div>
                    </div>
                     <div className="info-item"><span>📍 {address}</span></div>
                </div>
            </div>

            <Navbar service_name={get_data.service_name} />

            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1>{get_data.service_name}</h1>
                        <p>{get_data.description || "Providing excellent services and products tailored to your needs. Connect with us to know more."}</p>
                        <div style={{display: 'flex', gap: '16px', justifyContent: 'center'}}>
                            <a href="#products" className="btn btn-primary" style={{textDecoration:'none'}}>View Products</a>
                        </div>
                    </div>
                    <div className="hero-image">
                        <img src={get_data.featured_image || "https://images.unsplash.com/photo-1600880292203-757bb62b4baf"} alt="Hero" />
                    </div>
                </div>
            </section>

            <section className="section" id="about">
                <div className="container">
                    <div className="section-header">
                        <span>About Us</span>
                        <h2>Who We Are</h2>
                    </div>
                    <div style={{textAlign: 'center', maxWidth: '800px', margin: '0 auto'}}>
                        <p style={{fontSize: '1.1rem', color: 'var(--text-gray)'}}>
                            {get_data.description || `Welcome to ${get_data.service_name}. We are committed to delivering quality and satisfaction in every interaction.`}
                        </p>
                        <div style={{marginTop: '40px', display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
                             {categories.map((cat, i) => (
                                 <span key={i} style={{background: '#f1f5f9', padding: '10px 20px', borderRadius: '30px', fontWeight: '500', color: 'var(--primary)'}}>
                                     {cat.name}
                                 </span>
                             ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="section" id="products" style={{background: '#e2e8f0'}}>
                <div className="container">
                    <div className="section-header">
                        <span>Our Offerings</span>
                        <h2>Products & Services</h2>
                    </div>
                    <div className="grid-3">
                        {products.map((item, index) => (
                            <div className="card" key={index}>
                                <img 
                                    src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                    className="card-img" 
                                    alt={item.service_name} 
                                />
                                <div className="card-body">
                                    <h3 className="card-title">{item.service_name}</h3>
                                    {item.price && <span className="card-price">₹{item.price}</span>}
                                    <button onClick={() => addToCart(item)} className="btn btn-primary" style={{width: '100%'}}>
                                        Add to Cart
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    {products.length === 0 && <p style={{textAlign:'center'}}>No products listed.</p>}
                </div>
            </section>

            <section className="section" id="reviews">
                <div className="container">
                    <div className="section-header">
                        <span>Testimonials</span>
                        <h2>What Clients Say</h2>
                    </div>
                    <div className="grid-3">
                         {reviews.length > 0 ? reviews.map((rev, i) => (
                             <div className="review-card" key={i}>
                                 <div className="rating">★★★★★</div>
                                 <p style={{fontStyle: 'italic', marginBottom: '20px'}}>"{rev.review || "Great service!"}"</p>
                                 <h4 style={{fontSize: '1rem'}}>{rev.user_name || "Happy Client"}</h4>
                             </div>
                         )) : (
                             <p style={{textAlign: 'center', gridColumn: '1/-1'}}>No reviews yet.</p>
                         )}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Forththeme;
